import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Route,
  UrlSegment,
  UrlTree,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, AuthState } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class EnterpriseGuard {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const authState = this.auth.getAuthState();
    if (authState === AuthState.Anonymous) {
      return this.router.parseUrl('/rankings');
    }
    return true;
  }

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const authState = this.auth.getAuthState();
    if (authState === AuthState.Anonymous) {
      return false;
    }
    return true;
  }
}
